var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3336 53.5907C34.3996 40.6164 24.1998 41.4005 18.8416 43.4144C10.8735 41.5721 -2.89857 43.2783 5.75779 64.841C10.9089 78.0471 21.2671 72.4714 25.8024 68.0329C37.2912 65.7337 34.9436 57.4468 32.3336 53.5907Z",
    fill: "#E982E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9004 67.5972C40.2517 55.6694 32.241 62.1067 28.9418 66.8163C21.2911 69.8101 10.8423 79.0386 30.2527 92.0024C42.0158 100.027 47.4391 89.5281 48.6804 83.2754C56.9001 74.8508 50.2519 69.313 45.9004 67.5972Z",
    fill: "#E982E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9994 65.1342C42.9198 65.1104 45.0885 74.263 47.6829 78.8423C47.1474 86.3428 50.6638 98.6084 69.0132 87.6666C80.2727 81.1021 73.7292 72.4898 69.05 69.0042C65.3211 58.8972 58.1292 62.213 54.9994 65.1342Z",
    fill: "#E982E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5652 58.0152C55.7717 69.5461 65.7343 72.6035 71.5647 72.6908C78.4327 77.4066 92.1256 80.9209 91.9536 57.2519C91.991 42.812 80.0928 44.2383 74.139 46.7565C62.3898 44.6551 61.5276 53.3867 62.5652 58.0152Z",
    fill: "#E982E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8311 43.6299C67.5335 56.3795 76.5189 51.2674 80.5488 47.1176C88.626 45.3679 100.479 37.8737 83.275 21.8942C72.8758 12.0428 65.8104 21.6029 63.5776 27.6143C54.0668 34.6667 59.7837 41.2298 63.8311 43.6299Z",
    fill: "#E982E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1183 35.854C65.973 40.1768 66.9196 29.6589 65.7861 23.8597C69.0247 16.0631 69.6437 1.75092 46.2115 6.87453C31.8862 9.85926 35.7903 21.3581 39.5331 26.7344C39.9082 38.8236 48.7462 37.8513 53.1183 35.854Z",
    fill: "#E982E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.751 41.2499C51.1449 35.197 44.3172 26.9065 39.354 23.5178C36.1294 15.5602 26.3541 4.75678 13.0504 25.204C4.81171 37.5976 15.8519 43.1333 22.4018 44.3519C31.3089 52.8359 37.0126 45.8189 38.751 41.2499Z",
    fill: "#E982E5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 50.5,
    r: 30.5,
    fill: "#F9D2F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerFlower);
export default __webpack_public_path__ + "static/media/TimerFlower.e1242b614c0cd63bf6ee3222a5d69c62.svg";
export { ForwardRef as ReactComponent };